/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import { Button as PaperButton, useTheme } from 'react-native-paper';

const Button = ({ mode, style, disabled, children, ...props }) => {
  const theme = useTheme();

  const styles = StyleSheet.create({
    button: {
      width: '100%',
      marginVertical: 10,
      borderRadius: 8,
    },
    text: {
      fontWeight: 600,
      fontSize: 15,
      lineHeight: 26,
      color: theme.colors.onPrimaryContainer,
    },
    disabled: {
      backgroundColor: theme.colors.disabledColor,
      opacity: 0.7,
    },
    disabledText: {
      color: theme.colors.disabledTextColor,
    },
  });

  return (
    <PaperButton
      style={[styles.button, style, disabled && styles.disabled]}
      labelStyle={[styles.text, disabled && styles.disabledText]}
      mode={mode || 'contained'}
      disabled={disabled}
      {...props}
    >
      {children}
    </PaperButton>
  );
};

export default memo(Button);
